import {numberSpaceFormatter} from '@rocket-ui/tools';

export const BIK_DIGITS_LENGTH = 9;
export const BIK_NOT_FOUND_MESSAGE = 'Ничего не нашли';

export function extractBikDigits(value: string): string {
	return value.replace(/\D/g, '').slice(0, BIK_DIGITS_LENGTH);
}

export function formatBikDisplay(digits: string): string {
	const normalized = extractBikDigits(digits);

	if (!normalized) {
		return '';
	}

	return numberSpaceFormatter(normalized).toBik();
}

export function isBikValid(digits: string): boolean {
	return extractBikDigits(digits).length === BIK_DIGITS_LENGTH;
}
